var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ic-forms" },
    [
      !_vm.isSent
        ? _c("div", [
            _c("h2", { staticClass: "h3" }, [_vm._v("Formularz zgłoszeniowy")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ic-form__k-01" },
              [
                _c(
                  "FormWrapper",
                  { attrs: { validator: _vm.$v.form } },
                  [
                    _c("IcFormRowWrapper", {
                      attrs: {
                        id: "message",
                        rowElement: "IcFormRow",
                        name: "message",
                        aria: _vm.$t("aria_required"),
                        label: _vm.$t("label_message"),
                        labelWidth: 4,
                        controlWidth: 8,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ validator }) {
                              return [
                                _c("IcTextarea", {
                                  attrs: { id: "message" },
                                  on: {
                                    input: function ($event) {
                                      return _vm.emitInput(_vm.form, validator)
                                    },
                                  },
                                  model: {
                                    value: _vm.form.message,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "message", $$v)
                                    },
                                    expression: "form.message",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2707482858
                      ),
                    }),
                    _vm._v(" "),
                    _c("IcFormRowWrapper", {
                      attrs: {
                        id: "files",
                        name: "files",
                        rowElement: "IcFormRow",
                        label: _vm.$t("label_attachment"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ validator }) {
                              return [
                                _c("IcInputFile", {
                                  attrs: {
                                    id: "files",
                                    maxFiles: 3,
                                    v: validator,
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.emitInput(_vm.form, validator)
                                    },
                                  },
                                  model: {
                                    value: _vm.form.files,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "files", $$v)
                                    },
                                    expression: "form.files",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1842012714
                      ),
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-12" }, [
                        _c("small", [
                          _vm._v(_vm._s(_vm.$t("label_max_filesize"))),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("IcFormRowWrapper", {
                      attrs: {
                        id: "firstName",
                        rowElement: "IcFormRow",
                        name: "name",
                        aria: _vm.$t("aria_required"),
                        label: _vm.$t("label_name"),
                        labelWidth: 4,
                        controlWidth: 8,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ validator }) {
                              return [
                                _c("IcInput", {
                                  attrs: { id: "firstName" },
                                  on: {
                                    input: function ($event) {
                                      return _vm.emitInput(_vm.form, validator)
                                    },
                                  },
                                  model: {
                                    value: _vm.form.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "name", $$v)
                                    },
                                    expression: "form.name",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2099827628
                      ),
                    }),
                    _vm._v(" "),
                    _c("IcFormRowWrapper", {
                      attrs: {
                        id: "email",
                        rowElement: "IcFormRow",
                        name: "email",
                        aria: _vm.$t("aria_required"),
                        label: _vm.$t("label_email"),
                        labelWidth: 4,
                        controlWidth: 8,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ validator }) {
                              return [
                                _c("IcInput", {
                                  attrs: { id: "email", autocomplete: "email" },
                                  on: {
                                    input: function ($event) {
                                      return _vm.emitInput(_vm.form, validator)
                                    },
                                  },
                                  model: {
                                    value: _vm.form.email,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "email", $$v)
                                    },
                                    expression: "form.email",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        443799722
                      ),
                    }),
                    _vm._v(" "),
                    _c("IcFormAgreements", {
                      attrs: {
                        text: false,
                        header: false,
                        label:
                          "Niniejszym akceptuję i przyjmuję do stosowania postanowienia Regulaminu, co jest równoznaczne z wyrażeniem zgody na przetwarzanie danych osobowych podanych w zgłoszeniu. Administratorem danych osobowych jest PKP Intercity S.A z siedzibą Al. Jerozolimskie 142 A, 02-305 Warszawa. Informacja o przetwarzaniu danych osobowych znajduje się w treści Regulaminu.",
                      },
                      model: {
                        value: _vm.form.agreement,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "agreement", $$v)
                        },
                        expression: "form.agreement",
                      },
                    }),
                    _vm._v(" "),
                    _c("IcFormButtons", {
                      attrs: {
                        sending: _vm.isSending,
                        error: _vm.isError,
                        message: _vm.errorMessage,
                      },
                      on: { click: _vm.submit },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isSent
        ? _c("IcFormsSentMikol", { attrs: { data: _vm.sentData } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }